module.exports = __webpack_public_path__ + "media/images/instagram-social-network-logo-of-photo-camera-1c5558ef.svg";